'use strict';

angular.module('imagetrend.components')
    .controller('PhotoUploadModalController', ['$scope', '$uibModalInstance', 'Upload', 'Documents', 'file_content', function ($scope, $uibModalInstance, Upload, Documents, file_content) {

        $scope.file_content = file_content;
        $scope.uploading = false;
        $scope.uploaded_document_id = null;
        $scope.uploaded_document_code = null;
        $scope.uploaded_file_name = null;
        $scope.uploadMessage = null;
        $scope.errorMessage = null;

        $scope.resizeOptions = function () {
            return {
                quality: 1.0,
                width: 440,
                height: 440
            }
        }

        $scope.resizeConditions = function (file, width, height) {
            return width > 220 || height > 100;
        }

        $scope.fileUpdated = function (file) {
            $scope.uploaded_document_id = null;
            $scope.uploaded_document_code = null;
            $scope.errorMessage = null;
            if (file == null) {
                $scope.uploading = false;
                return;
            }

            function base64Fallback() {
                Upload.base64DataUrl(file).then(function (content) {
                    $scope.file_content = content;
                    $scope.uploading = false;
                });
            }

            Documents.storageAvailable().then(function (storageResponse) {
                if (storageResponse.documentStorageAvailable) {
                    // Keep a preview while uploading the file directly to blob storage.
                    Upload.base64DataUrl(file).then(function (content) {
                        $scope.file_content = content;
                    });
                    $scope.uploading = true;
                    $scope.uploadMessage = 'Uploading file...';
                    Documents.storageUpload(null, {
                        file: file,
                        name: file.name,
                        description: '',
                        document_type_id: null
                    }, function (progress) {
                        $scope.uploadMessage = 'Upload progress: ' + progress.percent + '%';
                    }).then(function (response) {
                        $scope.uploaded_document_id = response.data.id;
                        $scope.uploaded_document_code = response.data.code;
                        $scope.uploaded_file_name = response.data.file_name;
                        $scope.uploadMessage = 'Upload complete';
                        $scope.uploading = false;
                    }).catch(function (error) {
                        $scope.uploaded_document_id = null;
                        $scope.uploading = false;
                        $scope.errorMessage = 'Upload failed: ' + ((error && error.data && error.data.Message) || 'Please try again.');
                    });
                } else {
                    base64Fallback();
                }
            }).catch(function () {
                base64Fallback();
            });
        }

        $scope.filePicked = function () {
            $scope.uploading = true;
        }

        $scope.save = function (file, file_content) {
            if (file != null && $scope.uploaded_document_id != null) {
                $uibModalInstance.close({
                    document_id: $scope.uploaded_document_id,
                    document_code: $scope.uploaded_document_code,
                    file_name: $scope.uploaded_file_name || file.name,
                    is_new_upload: true
                });
            }
            else if (file != null) {
                $uibModalInstance.close({
                    file_name: file.name,
                    file_content: file_content
                });
            }
            else {
                $uibModalInstance.dismiss('cancel');
            }
        }

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }])
;